export enum ShipmentEventName {
  INSPECTION_START = 'INSPECTION_START',
  INSPECTION_END = 'INSPECTION_END',
  FLAGGED = 'FLAGGED',
  SOLVED = 'SOLVED',
  CANCELED = 'CANCELED',
}
